// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1902":"be39bbfcf28576d0","3066":"b902ab3a0242bcc3","3265":"af119b993b7d6f29","6392":"a366b3b37a9ec4a3","7429":"fd93d7a917f5122b","7654":"52c2f168405ac0c4","8801":"2d9bbadc56a6f2aa"}[chunkId] + ".js";
};